import { render, staticRenderFns } from "./LmHotels.vue?vue&type=template&id=6af45cca"
import script from "./LmHotels.vue?vue&type=script&lang=js"
export * from "./LmHotels.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports